import { SxProps, Theme } from '@mui/material/styles';

export const sectionSx: SxProps<Theme> = {
  width: '100vw',
  ml: 'calc(50% - 50vw)',
  mr: 'calc(50% - 50vw)',
  backgroundColor: '#123266',
  color: '#fff',
  pt: { xs: 6, md: 8 },
  pb: { xs: '10px', md: '10px' },
  mb: '10px',
};

export const heroTitleSx: SxProps<Theme> = {
  textAlign: 'center',
  fontWeight: 700,
  mb: 2,
  pb: '16px',
  pt: '36px',
  fontSize: { xs: '1.9rem', md: '2.8rem' },
};

export const heroDescriptionSx: SxProps<Theme> = {
  textAlign: 'center',
  fontWeight: 500,
  mb: { xs: 6, md: 8 },
  fontSize: { xs: '1.2rem', md: '1.8rem' },
  lineHeight: { xs: '1.5 !important', md: '1.4 !important' },
};

export const contentGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
  gap: { xs: 4, lg: 6 },
  alignItems: 'start',
};

export const leftContentSx: SxProps<Theme> = {
  '& *': { color: '#fff' },
  '& p': {
    margin: 0,
    mb: 2.5,
    lineHeight: '1.6 !important',
    fontSize: { xs: '0.95rem !important', md: '1rem !important' },
  },
  '& h1, & h2, & h3, & h4': {
    margin: 0,
    mb: 1.25,
    fontSize: { xs: '1.1rem !important', md: '1.2rem !important' },
    fontWeight: 700,
    fontStyle: 'italic',
  },
  '& ul, & ol': { margin: 0, pl: 3 },
  '& li': {
    mb: 1.2,
    lineHeight: '1.6 !important',
    fontSize: { xs: '0.95rem !important', md: '1rem !important' },
  },
};

export const rightContentSx: SxProps<Theme> = {
  border: '4px solid rgba(255, 255, 255, 0.85)',
  borderRadius: '24px',
  p: { xs: 3, md: 4 },
  '& *': { color: '#fff' },
  '& p': {
    margin: 0,
    mb: 2.5,
    lineHeight: '1.6 !important',
    fontSize: { xs: '0.95rem !important', md: '1rem !important' },
  },
  '& h1, & h2, & h3, & h4': {
    margin: 0,
    mb: 2,
    fontWeight: 700,
    fontSize: { xs: '1.7rem !important', md: '2rem !important' },
  },
  '& ul, & ol': { margin: 0, pl: 3 },
  '& li': {
    mb: 1.2,
    lineHeight: '1.6 !important',
    fontSize: { xs: '0.95rem !important', md: '1rem !important' },
  },
};
